export default {
    NOTHING: 0,
    REGIONAL: 1,
    SUPPORTING: 2,
    BOTH: 3
};
